export default "__VITE_ASSET__BVW580UA__"